
angular.module('app.controllers.squizsearch', ['ngLodash', 'infinite-scroll', 'ngSanitize'])
  .controller('SquizSearchController', ['$scope', '$sce', 'lodash', 'SquizSearchService',
      function ($scope, $sce, lodash, SquizSearchService,PagerService,$location, $anchorScroll) {

	    $scope.data = {};
	    $scope.options = { 'max': 10, 'facetQueries': [], 'englishFilters': true };
	    $scope.filterTranslations = {'Filters': 'Filtros', 'Page': 'Página', 'Language': 'Idioma', 'English': 'Inglés',
	    	'Spanish': 'Español', 'Media Type': 'Tipo de medio', 'video': 'vídeo', 'State': 'Estado',
	    	'Categories': 'Categorías', 'Residential': 'Residencial', 'Business': 'Negocio', 'Rates and regulation': 'Tarifas y regulaciones',
	    	'Careers': 'Empleo', 'Sustainability' : 'Sostenibilidad', 'Safety': 'La seguridad', 'Community': 'Comunidad', 'all': 'todas', 'Companywide': 'toda la empresa','Rebates and promotions':'Rebajas y promociones','Builders and contractors':'Constructores y contratistas','Bill payments':'pagos de facturas','Natural gas products':'Productos de gas natural','Save money and energy':'Ahorre Dinero y Energía','Assistance programs':'Programas de Asistencia',
	    	'Show Filters': 'Mostrar filtros', 'Hide Filters': 'Ocultar filtros', 'Show Advanced Search': 'Mostrar la búsqueda avanzada',
	    	'Hide Advanced Search': 'Ocultar Búsqueda avanzada'};
		var clickTrackingDomain = function() {
			
			if((window.location.hostname).indexOf("dev")!==-1){
			  return 'https://dxp-us-search.funnelback.squiz.cloud';
			}else if((window.location.hostname).indexOf("test")!==-1){
			  return 'https://dxp-us-search.funnelback.squiz.cloud';
			}else if((window.location.hostname).indexOf("uat")!==-1){
			  return 'https://swgas-search.funnelback.squiz.cloud';			  
			}else{
			  return 'https://swgas-search.funnelback.squiz.cloud';		
			}
		  };
		  
		$scope.clickTrackingDomainURL = clickTrackingDomain();
		$scope.IsVisibleCategories = false;
		$scope.ShowHideSearchCategories = function () {
			//If DIV is visible it will be hidden and vice versa.
			$scope.IsVisibleCategories = $scope.IsVisibleCategories ? false : true;
		};

		$scope.loadMore = function() { 
			$scope.options.append = true;
		    $scope.options.start_rank += $scope.options.max;
		    return SquizSearchService.findPages($scope.options, $scope.data);
		};
    
		var params = window.location.search.slice(1).split('&');
	 	var result = {};
	 	
	 	params.forEach(function(pair) {
	 		pair = pair.split('=');
	 		var val = decodeURIComponent(pair[1] || '');
	 		if (val !== '' && !isNaN(Number(val))) {
	 			val = parseInt(val);
	 		}
	 		result[pair[0]] = val;
	 	});
	 	
		//console.log("Result Query :"+result.query);
	 	result.query = result.query.replace(/\+/g, '%20');
	 	result.query = decodeURIComponent(result.query);
		if(result.query.indexOf("&quot;")!=-1)
		{ 
			result.query = result.query.replace("&quot;", "");
		}
		if(result.query.indexOf("\\\\")!=-1) 
		{
			result.query = result.query.replace("\\\\", "");
		}
		lodash.assign($scope.options, result);
	 	SquizSearchService.findPages($scope.options, $scope.data);
	 	
	 	$scope.filterSearchResult = function (filterValue) {
			//console.log("Filter Value :"+filterValue.toggleUrl);
			
			$scope.options.start_rank = 0;
			$scope.options.page = 1;

			if((filterValue.toggleUrl.indexOf("Spanish")!=-1) || (filterValue.toggleUrl.indexOf("Español")!=-1))  {        
	 			//$scope.options.englishFilters = !$scope.options.englishFilters;
	 			$scope.options.englishFilters = false;
	 		} else {				
	 			$scope.options.englishFilters = true;
			}
      
	 		//if($scope.options.facetQueries.includes(filterValue.toggleUrl)) {
	 			//lodash.pull($scope.options.facetQueries, filterValue.toggleUrl);
	 		//} else {
	 			//$scope.options.facetQueries.push(filterValue.toggleUrl);
	 		//}
			
			var toggleValue = '?';
			var tURL = filterValue.toggleUrl + '';			
			var toggleList = tURL.split('&');	
			
			toggleList.forEach(function(queryParam) {
				var keyfacet = queryParam.substring(queryParam.indexOf(":")+1,queryParam.indexOf("="));
				keyfacet = keyfacet.replace(/\+/g, '%20'); 
				keyfacet = decodeURIComponent(keyfacet);
				var valuefacet = queryParam.substring(queryParam.indexOf("=")+1,queryParam.length);	
				if ((keyfacet !== 'd') && (keyfacet !== '?')){ 
					toggleValue = toggleValue + '&' + keyfacet + '=' + valuefacet;
				}					
			});				
			//$scope.options.facetQueries = [filterValue.toggleUrl];			
			//console.log("Toggle Value:"+toggleValue);

			$scope.options.facetQueries = [toggleValue];

			
	 		SquizSearchService.findPages($scope.options, $scope.data);
	 	};
    
    
		$scope.setPage = function (page) {
			$scope.options.page = page;
			$scope.options.start_rank = page-1+"1";
			//$scope.options.start_rank = page;
			SquizSearchService.findPages($scope.options, $scope.data);
		};

 
	 	
	 	$scope.translateFilters = function() {
	 		$scope.options.englishFilters = !$scope.options.englishFilters;
	 	};
	 	
	 	$scope.trustSrc = function(src) {
			return $sce.trustAsResourceUrl(src);
	 	};
	 	
	 	//polyfill for Array.includes for Internet Explorer users
		// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	 	if (!Array.prototype.includes) {
	 	  Object.defineProperty(Array.prototype, 'includes', {
	 	    value: function(searchElement, fromIndex) {

	 	      // 1. Let O be ? ToObject(this value).
	 	      if (this === null) {
	 	        throw new TypeError('"this" is null or not defined');
	 	      }

	 	      var o = Object(this);

	 	      // 2. Let len be ? ToLength(? Get(O, "length")).
	 	      var len = o.length >>> 0;

	 	      // 3. If len is 0, return false.
	 	      if (len === 0) {
	 	        return false;
	 	      }

	 	      // 4. Let n be ? ToInteger(fromIndex).
	 	      //    (If fromIndex is undefined, this step produces the value 0.)
	 	      var n = fromIndex | 0;

	 	      // 5. If n ≥ 0, then
	 	      //  a. Let k be n.
	 	      // 6. Else n < 0,
	 	      //  a. Let k be len + n.
	 	      //  b. If k < 0, let k be 0.
	 	      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

	 	      // 7. Repeat, while k < len
	 	      while (k < len) {
	 	        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
	 	        // b. If SameValueZero(searchElement, elementK) is true, return true.
	 	        // c. Increase k by 1.
	 	        // NOTE: === provides the correct "SameValueZero" comparison needed here.
	 	        if (o[k] === searchElement) {
	 	          return true;
	 	        }
	 	        k++;
	 	      }

	 	      // 8. Return false
	 	      return false;
	 	    }
	 	  });
	 	}
	}]);